import { useCurrentAccount } from '@ferreri/minato-auth-react';
import { createQueryStore } from '@ferreri/minato-react-utils';
import { isWebView, sendWebViewEvent } from '@ferreri/prever-component-lib';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { getSessionCookie } from './web-view-message.client';

const useSessionCookie = () => {
  return createQueryStore({
    queryFn: getSessionCookie,
    queryKey: ['session-cookie'],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: isWebView(),
  });
};

export const useSendSessionToWebView = () => {
  const router = useRouter();
  const { data, isFetching } = useSessionCookie();

  useEffect(() => {
    if ((data?.ory_kratos_session, !isFetching && router.isReady)) {
      sendWebViewEvent({ event: 'session', data });
    }
  }, [data, isFetching, router.isReady]);
};

export const useSendAccountToWebView = () => {
  const router = useRouter();
  const { data, isFetching } = useCurrentAccount();

  useEffect(() => {
    if (data && !isFetching && router.isReady) {
      sendWebViewEvent({ event: 'account', data });
    }
  }, [data, isFetching, router.isReady]);
};
